// Auto-generated at build time, forces fresh queries after every deploy
// This guarantees that every deployment produces a new version automatically
export const API_VERSION = import.meta.env.VITE_BUILD_TIMESTAMP || Date.now().toString();
